export const MAX_COLOR_CHANNEL_VALUE = 255;
export const RGBA_CHANNEL_COUNT = 4;
export const RGB_CHANNEL_COUNT = 3;
export const ALPHA_CHANNEL_OFFSET = 3;
